import { addDays } from 'date-fns'
import { MIN_DATE } from '@/shared/constants/dates.constants'

export const LETTERS_AND_SPACES_MASK_CONFIG = {
  tokens: {
    '@': {
      pattern: /[a-zA-Z ]/,
      transform: (value: string) => value.replace(/\s{2,}/g, ' '),
      repeated: true,
    },
  },
  mask: '@',
}

export const PASSPORT_MASK_CONFIG = {
  tokens: {
    '@': {
      pattern: /[0-9a-zA-Z]/,
      repeated: true,
      transform: (chr: string) => chr.toUpperCase(),
    },
  },
  mask: '@',
}

export const BIRTH_MIN_DATE = addDays(MIN_DATE, 1)
export const BIRTH_DATE_DEFAULT_VALUE = new Date(1991, 0, 1)
